import storage from 'redux-persist/lib/storage';
import { persistReducer, createTransform } from 'redux-persist';
import combineReducer from './reducers/combineReducer';

// Transform для исключения статусов загрузки из персистора
const excludeLoadingStatusesTransform = createTransform(
  // transform state on its way to being serialized and persisted
  (inboundState, key) => {
    if (key === 'auth') {
      // Исключаем все статусы загрузки (pending/resolved/rejected)
      const { 
        sendCodeStatus,
        createTokenStatus,
        logoutStatus,
        giveRoleToNewUserRequestStatus,
        userProfileRequestStatus,
        generateAuthCodeStatus,
        ...restState 
      } = inboundState;
      
      return restState;
    }
    return inboundState;
  },
  // transform state being rehydrated
  (outboundState, key) => {
    if (key === 'auth') {
      // Восстанавливаем статусы в null при загрузке
      return {
        ...outboundState,
        sendCodeStatus: null,
        createTokenStatus: null,
        logoutStatus: null,
        giveRoleToNewUserRequestStatus: null,
        userProfileRequestStatus: null,
        generateAuthCodeStatus: null,
      };
    }
    return outboundState;
  },
  // define which reducers this transform gets called for
  { whitelist: ['auth'] }
);

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'common', 'nav'],
  timeout: 10000,
  transforms: [excludeLoadingStatusesTransform],
};

const persistedReducer = persistReducer(persistConfig, combineReducer);

export { persistedReducer };